(() => {
  const setupShippingPolicy = (root) => {
    root.querySelectorAll('[data-shipping-ceps-toggle]').forEach((button) => {
      if (button.dataset.shippingPolicyReady === 'true') return;

      button.dataset.shippingPolicyReady = 'true';
      button.addEventListener('click', () => {
        const content = document.getElementById(button.getAttribute('aria-controls'));
        if (!content) return;

        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        content.hidden = expanded;
      });
    });
  };

  setupShippingPolicy(document);

  document.addEventListener('shopify:section:load', (event) => {
    setupShippingPolicy(event.target);
  });
})();
